<script setup lang="ts">
import { computed, ref } from 'vue'
import http from '@/services/http'
import { useI18n } from 'vue-i18n'
import { genRouteID, viewing } from '@/services/utils'

const { t } = useI18n()
const model = computed(() => sessionMap.user.instances)
const view = ref(viewing.value)

const currentInstance = computed(() => {
	if (viewing.value) {
		const instance = model.value.find((i) => i.id === viewing.value)
		return instance ? instance.name : ''
	}
	return t('misc.all')
})

const handleSelectChange = async () => {
	sessionStorage.clear()
	const url = new URL(window.location.href)
	url.search = ''
	history.pushState({}, '', url.toString())
	if (window.location.href.includes('/bp/view/')) {
		window.location.href = '/app/bp'
	}
	await fetchView(genRouteID(view.value, '', 'Instance'))
}

const fetchView = async (instanceId: string) => {
	await http.get(`/api/view/${instanceId}`)
	window.location.reload()
}
</script>

<template>
	<template v-if="model.length > 1">
		<div class="container-center">
			<div class="icon-wrapper" v-one-tooltip="currentInstance">
				<select id="view-select" data-test="view-select" v-model="view" class="form-control select-box" @change="handleSelectChange">
					<option :value="0">{{ t('misc.all') }}</option>
					<option v-for="instance in model" :key="instance.id" :value="instance.id">
						{{ instance.name }}
					</option>
				</select>

				<span class="overlay-content">
					<i class="bi bi-building fs-5"></i>
					<span class="text-truncate current-instance">
						<b>{{ currentInstance }}</b>
					</span>
					<i class="bi bi-justify fs-5"></i>
				</span>
			</div>
		</div>
	</template>
	<template v-else>
		<h4><i class="bi bi-building"></i>{{ currentInstance }}</h4>
	</template>
</template>

<style lang="sass" scoped>
@import ~bootstrap/scss/functions
@import ~bootstrap/scss/variables

.container-center
  width: 100%
  display: flex
  flex-direction: column
  align-items: center
  position: absolute
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)

.icon-wrapper
  width: 100%
  display: inline-flex
  align-items: center
  position: relative
  max-width: 300px
  flex-shrink: 0
  color: $secondary
  &:hover
    color: $primary

  @media (max-width: 1000px)
    transform: scale(0.9)
  @media (max-width: 900px)
    transform: scale(0.8)
.select-box
  cursor: pointer
  text-indent: -9999px


.overlay-content
  display: inline-flex
  justify-content: space-between
  align-items: center
  width: 100%
  padding: 0 0.5rem
  position: absolute
  top: 50%
  left: 0
  transform: translateY(-50%)
  pointer-events: none

.current-instance
  max-width: 220px
</style>
